module.exports = __webpack_public_path__ + "img/shop_rooms.82e534e.png";